import { Outlet, createRootRouteWithContext, useNavigate, useRouterState } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { signOut } from "../lib/auth";
import { TopBar, Footer } from "../components/ui";

interface RouterCtx {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterCtx>()({
  component: RootLayout,
});

function RootLayout() {
  const me = useQuery({ queryKey: ["me"], queryFn: () => api.me(), retry: false });
  const user = me.isSuccess && me.data ? me.data : null;
  const qc = useQueryClient();
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  async function onSignOut() {
    await signOut();
    qc.clear();
    navigate({ to: "/" });
  }

  const isLogin = pathname === "/login";
  const showFooter = pathname === "/" && !user;

  return (
    <div className="min-h-screen">
      {!isLogin && <TopBar user={user} onSignOut={onSignOut} />}
      <Outlet />
      {showFooter && <Footer />}
    </div>
  );
}
